angular.module('bmsApp.trugreen').factory('TGInvoiceSvc', function ($q,
                                                                    $modal,
                                                                    $rootScope,
																	CRUDSvc,
                                                                    TG_INVOICE_API) {

	var self = {

		save: function (params) {
			return CRUDSvc.post(TG_INVOICE_API.SAVE, params);
		},
        preInvoice: function(visitId){
            return CRUDSvc.post(TG_INVOICE_API.PREINVOICE + visitId);
        },
        getInvoiceTypeOptions: function(){
            return CRUDSvc.get(TG_INVOICE_API.GETINVOICETYPEOPTIONS);
        },

        showPreModal: function () {
            var modalInstance = $modal.open({
                animation: true,
                templateUrl: 'ng/trugreen/job/templates/modals/PrintInvoiceModal.html',
                controller: 'PrintInvoiceModalCtrl',
                size: 'md',
                scope: $rootScope,
                backdrop: 'static', // disable click-outside closing modal
            });

            return modalInstance.result;

        },


    };
	return self;

}).constant('TG_INVOICE_API', {
    SAVE: 'api/trugreen/invoice/save',
    PREINVOICE: 'api/trugreen/visit/pre-invoice/',
    GETINVOICETYPEOPTIONS: 'api/trugreen/invoice/get-invoice-type-options'
});
